import MaleGood from "./images/sub/illust_circle_doctor2.png";
import MaleBad from "./images/sub/illust_circle_doctor2_1.png";
import FemaleGood from "./images/sub/illust_circle_doctor1.png";
import FemaleBad from "./images/sub/illust_circle_doctor1_2.png";

import ICBPEmpty from "./images/icon/icon_pencil_heart_gary.png";
import ICMedicineEmpty from "./images/icon/icon_medic_pencil.png";

import ICBPDeviceNothing from "./images/icon/icon_device_nothing.png";
import ICBPDeviceNothing2 from "./images/icon/icon_device_nothing2.png";
import ICBPDeviceSuccess from "./images/icon/icon_connect_success.png";
import ICBPDeviceFailure from "./images/icon/icon_connect_fail.png";
import ICBPDeviceGuide from "./images/sub/device_link_guide.jpg";
import ICBPAccucheckGuide from "./images/sub/device_link_guide_accucheck.png";

import IC_CHECK_BG_WHITE from "./images/icon/icon_chk_b.png";
import IC_DELETE_GRAY from "./images/icon/icon_delete_min_gray.png";


import ICMyPharmacyEmpty from "./images/icon/icon_medicine_bowl.png";
import ICNearByPharmacyEmpty from "./images/icon/icon_medicine_bowl2.png";
import ICSearchPharmacyEmpty from "./images/icon/icon_medicine_bowl3.png";

import ICEocsIngEmpty from "./images/icon/icon_medicine_list.png";
import ICEocsEndEmpty from "./images/icon/icon_medicine_check.png";

import ICTellephone from "./images/icon/icon_btn_inth1.png";
import ICTitle from "./images/icon/icon_title_white.png";
import ICTitleColor from "./images/icon/icon_title.png";
import ICTitle2 from "./images/main/AD1_image.png";

import ICCalendar from "./images/icon/calendar.png";

// 운동
import ILST_WALKING from "./images/sub/illust_exercise01.png";
import ILST_WALKING2 from "./images/sub/illust_exercise02.png";
import ILST_RUNNING from "./images/sub/illust_exercise03.png";
import ILST_SWIMING from "./images/sub/illust_exercise04.png";
import ILST_MOUNTAIN from "./images/sub/illust_exercise05.png";
import ILST_RIDING from "./images/sub/illust_exercise06.png";
import ILST_GYM from "./images/sub/illust_exercise07.png";
import ILST_TENNIS from "./images/sub/illust_exercise08.png";
import ILST_SQUASY from "./images/sub/illust_exercise09.png";
import ILST_GOLF from "./images/sub/illust_exercise10.png";
import ILST_YOGA from "./images/sub/illust_exercise11.png";
import ILST_PILATES from "./images/sub/illust_exercise12.png";
import ILST_STRETCHING from "./images/sub/illust_exercise13.png";

// 도움이필요하신가요?
import ICVISIT01 from "./images/icon/icon_visit_01.png";
import ICVISIT02 from "./images/icon/icon_visit_02.png";

// 병원 내부인가요?
import ICVISIT03 from "./images/icon/icon_pw_01.png";
import ICVISIT04 from "./images/icon/icon_pw_02.png";

import ICARROWDOWN from "./images/icon/icon_arrow_wp_down_pp_min.png";
import ICARROWDOWNSILVER from "./images/icon/icon_select_arrow_default.png";
import ICARROWUPSILVER from "./images/icon/icon_select_arrow_default_up.png";
import IC_LOCATION from "./images/icon/icon_location_line.png";

import AD1_THUMNAIL from "./images/main/AD1_image.png";

// 스케쥴 아이콘
import IC_SCHEDULE_COMPLETE from "./images/icon/newIcon/icon_inspection_confirm_past.svg";
// import IC_SCHEDULE_COMPLETE_ON from "./images/icon/newIcon/icon_inspection_confirm.svg";
import IC_SCHEDULE_HOLD from "./images/icon/newIcon/icon_inspection_waiting_past.svg";
// import IC_SCHEDULE_HOLD_ON from "./images/icon/newIcon/icon_inspection_waiting.svg";

import IC_SCHEDULE_RECEIPT_COMPLETE from "./images/icon/icon_schedule_receipt_complete.svg";
import IC_SCHEDULE_RECEIPT_COMPLETE_ON from "./images/icon/icon_schedule_receipt_complete_on.svg";
import IC_SCHEDULE_RECEIPT_HOLD from "./images/icon/icon_schedule_receipt_hold.svg";
import IC_SCHEDULE_RECEIPT_HOLD_ON from "./images/icon/icon_schedule_receipt_hold_on.svg";

import IC_SCHEDULE_WATING from "./images/icon/newicon/icon_inspection_waiting.svg";
import IC_SCHEDULE_CONFIRM from "./images/icon/newicon/icon_inspection_confirm.svg";
import IC_SCHEDULE_CANCEL from "./images/icon/newicon/icon_inspection_cancel.svg";
import IC_SCHEDULE_DASH from "./images/icon/newicon/iconBasic_dash.png";

// 수축기 이완기 아이콘
import IC_MAX_BP from "./images/icon/Icon awesome-compress-arrows-alt.svg";
import IC_MIN_BP from "./images/icon/Icon awesome-expand-arrows-alt.svg";

import IC_BUY_ANIMATION from "./images/icon/newIcon/icon_animation_buy.gif";
import IC_BUY_ANIMATION36 from "./images/icon/newIcon/icon_animation_buy36.gif";

import IC_TOP_GREEN from "./images/main/contents_top_green.jpg";
import IC_INSPEC from "./images/icon/newIcon/icon_inspec_note.png";

// 화살표 좌우
import ARROW_LEFT_GREY from "./images/icon/btn_arrow_gray_prev.png";
import ARROW_RIGHT_GREY from "./images/icon/btn_arrow_gray_next.png";
import ARROW_RIGHT_DARK_SRC from "./images/icon/icon_arrow_right_min_dark.png";
export const ARROW_RIGHT_DARD = ARROW_RIGHT_DARK_SRC;

// gluneo image
import STEP1 from "./images/setting/gluneo/a01.png";
import STEP2 from "./images/setting/gluneo/a02.png";
import STEP3 from "./images/setting/gluneo/a03.png";
import STEP4 from "./images/setting/gluneo/a04.png";
import STEP5 from "./images/setting/gluneo/a05.png";
import ARROW from "./images/setting/gluneo/arrow.gif";

import GREENSMILE from "./images/icon/face_smile.png";
import GREENGLOOM from "./images/icon/face_gloom.png";

// omron image
import OMRON_BT_CHECK from "./images/setting/omron/omron_bt_check.png";
import OMRON_BT_PAIRING from "./images/setting/omron/omron_bt_pairing.png";
import OMRON_BT_PAIRING_POPUP_CHECK from "./images/setting/omron/omron_pairing_popup_check.png";
import OMRON_BT_PAIRING_POPUP from "./images/setting/omron/omron_pairing_popup.png";
import OMRON_BT_CONNECTED from "./images/setting/omron/omron_bt_connected.png";
import OMRON_BT_CONNECT_START from "./images/setting/omron/omron_bt_connect_start.png";

import THUMNAILACCUCHECK from "./images/setting/accucheck/thumnail.png";
import THUMNAILOMRON from "./images/setting/omron/thumnail.png";
import THUMNAILBP170B from "./images/setting/bp170b/thumnail.png";

import IC_SETTING_GREY from "./images/icon/Iconfeather-settings.svg";
import IC_BLOOD from "./images/icon/noun-blood-4331595.svg";
import IC_EMPTY_STOMACH from "./images/icon/newIcon/icon-empty-stomach.png";
import IC_MAP_FOOD from "./images/icon/newIcon/icon-map-food.png";

import IC_CIRCLE_PLUS from "./images/icon/icon_circle_plus.png";
import IC_SYRINGE from "./images/icon/newIcon/Icon awesome-syringe.png";
import IC_NOTE from "./images/icon/newIcon/icon_note.png";
import IC_EDIT from "./images/icon/newIcon/icon_edit.png";

// LOGIN IMAGE
import IC_LOGIN_KAKAO from "./images/icon/login/kakao_enter.png";
import IC_LOGIN_NAVER from "./images/icon/login/naver_enter.png";
import IC_LOGIN_APPLE from "./images/icon/login/apple_enter.png";

import ID_LOGIN_KAKAO from "./images/icon/login/id_kakao.png";
import ID_LOGIN_NAVER from "./images/icon/login/id_naver.png";
import ID_LOGIN_APPLE from "./images/icon/login/id_apple.png";
import IC_GRAY_CERTIFI from "./images/icon/icon_gray_certifi.png";
import IC_GRAY_SEARCH from "./images/icon/btn_search_gray.png";
import IC_BLACK_PLUS from "./images/icon/times-circle.svg";
import IC_PEN_GRAY from "./images/icon/icon_modify.svg";

// checkbox
import IcCheckOn from "./images/icon/icon_checkbox_on.png";
import CheckCirclePurple from "./images/icon/icon_checkbox_cirpp_on.png";
export const CheckCirclePurpleSrc = CheckCirclePurple;
import CheckCircleGray from "./images/icon/icon_checkbox_cirpp_off.png";
export const CheckCircleGraySrc = CheckCircleGray;

import ArrowLeft from "./images/icon/ArrowLeft.svg";
export const ArrowLeftSrc = ArrowLeft;

import LogoMin from "./images/icon/careforme_logo_purple.svg";
export const LogoMinSrc = LogoMin;

import AppleLogin from "./images/icon/login/Apple_Acnt.svg";
export const AppleLoginSrc = AppleLogin;
import NaverLogin from "./images/icon/login/Naver_Acnt.svg";
export const NaverLoginSrc = NaverLogin;
import KakaoLogin from "./images/icon/login/Kakao_Acnt.svg";
export const KakaoLoginSrc = KakaoLogin;

import CheveronUpCircle from "./images/icon/chevron-up-circle.svg";
export const CheveronUpCircleSrc = CheveronUpCircle;

import CircleNo1 from "./images/icon/circle-no-1.svg";
export const CircleNo1Src = CircleNo1;
import CircleNo2 from "./images/icon/circle-no-2.svg";
export const CircleNo2Src = CircleNo2;
import CircleNo3 from "./images/icon/circle-no-3.svg";
export const CircleNo3Src = CircleNo3;

import PrivTermsImg1 from "./images/terms/private/img_1.png";
export const PrivTermsImg1Src = PrivTermsImg1;
import PrivTermsImg2 from "./images/terms/private/img_2.png";
export const PrivTermsImg2Src = PrivTermsImg2;

import PrivTermsImg20240628_1 from "./images/terms/private/20240628_1.png";
export const PrivTermsImg20240628_1Src = PrivTermsImg20240628_1;
import PrivTermsImg20240628_2 from "./images/terms/private/20240628_2.png";
export const PrivTermsImg20240628_2Src = PrivTermsImg20240628_2;

import NftfWating from "./images/icon/icon_inspection_waiting.svg";
export const NftfWatingSrc = NftfWating;

import ExclamationCircle from "./images/icon/exclamation-circle.svg";
export const ExclamationCircleSrc = ExclamationCircle;

import LoadingImg from "./images/icon/progress.gif";
export const LoadginImgSrc = LoadingImg;

import BlackX from "./images/icon/newIcon/BlackX.svg";
export const BlackXSrc = BlackX;

import ICON_MINUS from "./images/icon/icon_minus_circle_min.png";
export const ICON_MINUS_SRC = ICON_MINUS;

import ICON_RED_MINUS from "./images/nftf/cardList/deleteCard.svg";
export const ICON_RED_MINUS_SRC = ICON_RED_MINUS;

import ICON_CHEVRON_LEFT from "./images/nftf/chevron-left.svg";

// 비대면 리스트 컴포넌트
import ICON_LIST_TIME from "./images/nftf/receiptList/time.svg";
import ICON_LIST_COMMENT from "./images/nftf/receiptList/comment.svg";
import ICON_LIST_CARD from "./images/nftf/receiptList/card.svg";
import ICON_LIST_IDCARD from "./images/nftf/receiptList/idCard.svg";
import ICON_LIST_MEDICAL from "./images/nftf/receiptList/medical.svg";

import ICON_LIST_R_ICON_CHEVRON from "./images/nftf/receiptList/R_ICON/chevron-right.svg";
import ICON_LIST_R_ICON_CHEVRON_VIOLET from "./images/nftf/receiptList/R_ICON/chevron-right_violet.svg";
import ICON_R_ICON_SEARCH from "./images/nftf/receiptList/R_ICON/search.svg";
import ICON_R_ICON_HEART_GRAY from "./images/nftf/receiptList/R_ICON/heartGray.svg";
import ICON_R_ICON_HEART_PURPLE from "./images/nftf/receiptList/R_ICON/heartPurple.svg";

import ICON_PILL from "./images/layer/icon_pill.svg";

import ICON_CIRCLE_POINT_PURPLE from "./images/icon/circle_point_purple.svg";
import ICON_X_CIRCLE from "./images/nftf/receiptList/R_ICON/xCircle.svg";
import ICON_LOCATION_ITEM from "./images/icon/location-item.svg";

import ICON_CAMERA_GREEN from "./images/icon/icon_camera_green.svg";
import ICON_NFTF_NOTICE from "./images/nftf/nftf_notice.png";

import ICON_NFTF_GUIDE_1 from "./images/nftf/nftf_guide_1.png";
import ICON_NFTF_GUIDE_2 from "./images/nftf/nftf_guide_2.png";
import ICON_NFTF_GUIDE_3 from "./images/nftf/nftf_guide_3.png";
import ICON_NFTF_GUIDE_4 from "./images/nftf/nftf_guide_4.png";
import ICON_NFTF_GUIDE_5 from "./images/nftf/nftf_guide_5.png";

import ICON_HSPT_DEFAULT from "./images/nftf/hospital_default.svg";
import ICON_USER_AVATAR_DEFAULT from "./images/nftf/icon_user.svg";
import ICON_POINT_GREEN from "./images/nftf/icon_point_green.svg";
import ICON_COUPON from "./images/nftf/icon_coupon.svg";
import ICON_PURPLE_CHECK from "./images/icon/icon_purple_check.svg";
import ICON_GREEN_CHECK from "./images/icon/icon_green_check.svg";

import ICON_TERMS from "./images/icon/ICON_TERMS.svg";
import ICON_BUILDING from "./images/icon/ICON_BUILDING.svg";
import ICON_LOGOUT from "./images/icon/ICON_LOGOUT.svg";

import ICON_HSPT_CNNT from "./images/myPage/hospitalConnection.svg";
import ICON_CPN from "./images/myPage/coupon.svg";
import ICON_PHONE_CNNT from "./images/myPage/phoneConnect.svg";

import ICON_LAYER_COUPON from "./images/layer/coupon.png";
import ICON_GRAY_PLUS from "./images/icon/newIcon/plus.svg";
import ICON_CLOSE_X from "./images/icon/btn_closex_min_d.png";
import ICON_GALLERY from "./images/icon/image-duotone 2.svg";
import ICON_CAMERA from "./images/icon/camera-duotone 2.svg";
import ICON_CARD_GRAY from "./images/icon/ICON_CARD_GRAY.svg";
import ICON_NOTICE_GRAY from "./images/nftf/IconNotiveGray.svg";
import ICON_NOTICE_PURPLE from "./images/nftf/exclamation-circle.svg";

// 지도 마커
import ICON_MAP_HSPT_MARKER from "./images/icon/hospitalMarker.svg";
import ICON_MAP_PHARM_MARKER from "./images/icon/pharmacyMarker.svg";
import ICON_MAP_MY_MARKER from "./images/icon/marker_my.svg";
import ICON_MAP_ZOOM_PLUS from "./images/icon/zoomPlus.svg";
import ICON_MAP_ZOOM_MINUS from "./images/icon/zoomMinus.svg";

import ICNoFileList from "./images/icon/icon_files_two.png";

export const Doctor = {
  male: { laugh: MaleGood, serious: MaleBad, good: MaleGood, bad: MaleBad },
  female: {
    laugh: FemaleGood,
    serious: FemaleBad,
    good: FemaleGood,
    bad: FemaleBad,
  },
};

export const IC = {
  empty: {
    bp: ICBPEmpty,
    medicine: ICMedicineEmpty,
    myPh: ICMyPharmacyEmpty,
    nearByPh: ICNearByPharmacyEmpty,
    searchPh: ICSearchPharmacyEmpty,
    eocsIng: ICEocsIngEmpty,
    eocsEnd: ICEocsEndEmpty,
  },
  device: {
    nothing: ICBPDeviceNothing,
    nothing2: ICBPDeviceNothing2,
    success: ICBPDeviceSuccess,
    failure: ICBPDeviceFailure,
    guide: ICBPDeviceGuide,
  },
  etc: {
    tellphone: ICTellephone,
    title: ICTitle,
    title2: ICTitle2,
    visit01: ICVISIT01,
    visit02: ICVISIT02,
    visit03: ICVISIT03,
    visit04: ICVISIT04,
    calendar: ICCalendar,
    arrowDown: ICARROWDOWN,
    location: IC_LOCATION,
    AD1_THUMNAIL: AD1_THUMNAIL,
    IC_TOP_GREEN: IC_TOP_GREEN,
    ICTitleColor: ICTitleColor,

    ARROW_LEFT_GREY: ARROW_LEFT_GREY,
    ARROW_RIGHT_GREY: ARROW_RIGHT_GREY,
    IC_INSPEC: IC_INSPEC,
    IC_ARROW_UP_SILVER: ICARROWUPSILVER,
    IC_ARROW_DOWN_SILVER: ICARROWDOWNSILVER,
    IC_SETTING_GREY: IC_SETTING_GREY,
    IC_BLOOD: IC_BLOOD,

    IC_EMPTY_STOMACH: IC_EMPTY_STOMACH,
    IC_MAP_FOOD: IC_MAP_FOOD,
    IC_CIRCLE_PLUS: IC_CIRCLE_PLUS,

    IC_SYRINGE: IC_SYRINGE,
    IC_NOTE: IC_NOTE,
    IC_EDIT: IC_EDIT,
    IC_GRAY_SEARCH: IC_GRAY_SEARCH,
    IC_GRAY_CERTIFI: IC_GRAY_CERTIFI,

    IC_BLACK_PLUS: IC_BLACK_PLUS,
    IC_PEN_GRAY: IC_PEN_GRAY,
    ICON_CHEVRON_LEFT: ICON_CHEVRON_LEFT,

    ICON_PILL: ICON_PILL,
    ICON_CIRCLE_POINT_PURPLE: ICON_CIRCLE_POINT_PURPLE,
    ICON_X_CIRCLE: ICON_X_CIRCLE,
    ICON_LOCATION_ITEM: ICON_LOCATION_ITEM,

    ICON_NFTF_NOTICE: ICON_NFTF_NOTICE,
    ICON_HSPT_DEFAULT: ICON_HSPT_DEFAULT,

    ICON_USER_AVATAR_DEFAULT: ICON_USER_AVATAR_DEFAULT,
    ICON_POINT_GREEN: ICON_POINT_GREEN,

    ICON_BUILDING: ICON_BUILDING,
    ICON_LOGOUT: ICON_LOGOUT,
    ICON_TERMS: ICON_TERMS,
    ICON_GRAY_PLUS: ICON_GRAY_PLUS,

    ICON_GALLERY: ICON_GALLERY,
    ICON_CAMERA: ICON_CAMERA,
    ICON_NO_FILE_LIST: ICNoFileList,
  },
  check: {
    IC_CHECK_BG_WHITE: IC_CHECK_BG_WHITE,
    IcCheckOn: IcCheckOn,
    ICON_PURPLE_CHECK: ICON_PURPLE_CHECK,
    ICON_GREEN_CHECK: ICON_GREEN_CHECK,
  },
  delete: {
    IC_DELETE_GRAY: IC_DELETE_GRAY,
  },
  schedule: {
    IC_SCHEDULE_COMPLETE: IC_SCHEDULE_COMPLETE,
    // IC_SCHEDULE_COMPLETE_ON:IC_SCHEDULE_COMPLETE_ON,
    IC_SCHEDULE_HOLD: IC_SCHEDULE_HOLD,
    // IC_SCHEDULE_HOLD_ON:IC_SCHEDULE_HOLD_ON,

    IC_SCHEDULE_RECEIPT_COMPLETE: IC_SCHEDULE_RECEIPT_COMPLETE,
    IC_SCHEDULE_RECEIPT_COMPLETE_ON: IC_SCHEDULE_RECEIPT_COMPLETE_ON,
    IC_SCHEDULE_RECEIPT_HOLD: IC_SCHEDULE_RECEIPT_HOLD,
    IC_SCHEDULE_RECEIPT_HOLD_ON: IC_SCHEDULE_RECEIPT_HOLD_ON,

    IC_SCHEDULE_WATING: IC_SCHEDULE_WATING,
    IC_SCHEDULE_CONFIRM: IC_SCHEDULE_CONFIRM,
    IC_SCHEDULE_CANCEL: IC_SCHEDULE_CANCEL,
    IC_SCHEDULE_DASH: IC_SCHEDULE_DASH,
  },
  bp: {
    IC_MAX_BP: IC_MAX_BP,
    IC_MIN_BP: IC_MIN_BP,
    IC_BUY_ANIMATION: IC_BUY_ANIMATION36,
  },
  gluneo: {
    STEP1: STEP1,
    STEP2: STEP2,
    STEP3: STEP3,
    STEP4: STEP4,
    STEP5: STEP5,
    ARROW: ARROW,
  },
  accucheck: {
    THUMNAIL: THUMNAILACCUCHECK,
  },
  omron: {
    THUMNAIL: THUMNAILOMRON,
    OMRON_BT_CHECK: OMRON_BT_CHECK,
    OMRON_BT_PAIRING: OMRON_BT_PAIRING,
    OMRON_BT_PAIRING_POPUP_CHECK: OMRON_BT_PAIRING_POPUP_CHECK,
    OMRON_BT_PAIRING_POPUP: OMRON_BT_PAIRING_POPUP,
    OMRON_BT_CONNECTED: OMRON_BT_CONNECTED,
    OMRON_BT_CONNECT_START: OMRON_BT_CONNECT_START,
  },
  bp170b: {
    THUMNAIL: THUMNAILBP170B,
  },

  faceIcon: {
    GREENSMILE: GREENSMILE,
    GREENGLOOM: GREENGLOOM,
  },
  login: {
    IC_LOGIN_KAKAO: IC_LOGIN_KAKAO,
    IC_LOGIN_NAVER: IC_LOGIN_NAVER,
    IC_LOGIN_APPLE: IC_LOGIN_APPLE,

    ID_LOGIN_KAKAO: ID_LOGIN_KAKAO,
    ID_LOGIN_NAVER: ID_LOGIN_NAVER,
    ID_LOGIN_APPLE: ID_LOGIN_APPLE,
  },
  camera: {
    ICON_CAMERA_GREEN: ICON_CAMERA_GREEN,
  },
  nftfGuide: {
    ICON_NFTF_GUIDE_1: ICON_NFTF_GUIDE_1,
    ICON_NFTF_GUIDE_2: ICON_NFTF_GUIDE_2,
    ICON_NFTF_GUIDE_3: ICON_NFTF_GUIDE_3,
    ICON_NFTF_GUIDE_4: ICON_NFTF_GUIDE_4,
    ICON_NFTF_GUIDE_5: ICON_NFTF_GUIDE_5,
  },
  myPage: {
    ICON_HSPT_CNNT: ICON_HSPT_CNNT,
    ICON_CPN: ICON_CPN,
    ICON_PHONE_CNNT: ICON_PHONE_CNNT,
  },
  layer: {
    ICON_LAYER_COUPON: ICON_LAYER_COUPON,
  },
  close: {
    ICON_CLOSE_X: ICON_CLOSE_X,
  },
  card: {
    ICON_CARD_GRAY: ICON_CARD_GRAY,
  },

  notice: {
    ICON_NOTICE_GRAY: ICON_NOTICE_GRAY,
    ICON_NOTICE_PURPLE: ICON_NOTICE_PURPLE,
  },

  marker: {
    ICON_MAP_HSPT_MARKER: ICON_MAP_HSPT_MARKER,
    ICON_MAP_PHARM_MARKER: ICON_MAP_PHARM_MARKER,
    ICON_MAP_MY_MARKER: ICON_MAP_MY_MARKER,
  },

  map: {
    ICON_MAP_ZOOM_PLUS: ICON_MAP_ZOOM_PLUS,
    ICON_MAP_ZOOM_MINUS: ICON_MAP_ZOOM_MINUS,
  },
};

export const getSrc = set => {
  let image = "";
  for (let i in set) {
    const img = set[i];
    const num = parseInt(i);
    if (num !== 0) {
      image += ", ";
    }
    image += `${img} ${num + 1}x`;
  }
  return image;
};

export const getBackground = set => {
  let image = "";
  for (let i in set) {
    const img = set[i];
    const num = parseInt(i);
    if (num !== 0) {
      image += ", ";
    }
    image += `url(${img}) ${num + 1}x`;
  }
  return image;
};

export const IlustExercise = {
  walking: ILST_WALKING,
  walkWithPet: ILST_WALKING2,
  running: ILST_RUNNING,
  swiming: ILST_SWIMING,
  mountain: ILST_MOUNTAIN,
  riding: ILST_RIDING,
  gym: ILST_GYM,
  tennis: ILST_TENNIS,
  squasy: ILST_SQUASY,
  golf: ILST_GOLF,
  yoga: ILST_YOGA,
  pilates: ILST_PILATES,
  stretching: ILST_STRETCHING,
};

export const ListIcon = {
  RECEIPT: {
    L_ICON: {
      TIME: ICON_LIST_TIME,
      CARD: ICON_LIST_CARD,
      COMMENT: ICON_LIST_COMMENT,
      MEDICAL: ICON_LIST_MEDICAL,
      IDCARD: ICON_LIST_IDCARD,
      COUPON: ICON_COUPON,
    },

    R_ICON: {
      CHEVRON_DEFAULT: ICON_LIST_R_ICON_CHEVRON,
      CHEVRON_ACTIVE: ICON_LIST_R_ICON_CHEVRON_VIOLET,
      SEARCH: ICON_R_ICON_SEARCH,
      HEART_GRAY: ICON_R_ICON_HEART_GRAY,
      HEART_PURPLE: ICON_R_ICON_HEART_PURPLE,
    },
  },
};